const HomeIcon = ({ viewBox = "0 0 20 20", className = "hayley-h-5 hayley-w-5 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path d="M0.9375 9.0625L10.3125 1.5625L19.6875 9.0625" stroke="currentColor" strokeMiterlimit="10" />
      <path d="M3.4375 10.3125V19.0625H17.1875V10.3125" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M14.6871 16.5621L11.8965 13.7715" stroke="currentColor" strokeMiterlimit="10" />
      <path
        d="M9.6875 14.6875C11.4134 14.6875 12.8125 13.2884 12.8125 11.5625C12.8125 9.83661 11.4134 8.4375 9.6875 8.4375C7.96161 8.4375 6.5625 9.83661 6.5625 11.5625C6.5625 13.2884 7.96161 14.6875 9.6875 14.6875Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default HomeIcon;
